import React, { useEffect, Suspense } from "react";
import {
  Navigate,
  RouterProvider,
  createHashRouter,
  useLocation,
} from "react-router-dom";
import routes from "./routes";
import { useSelector } from "react-redux";
import {
  AUTH_STATUS,
  selectPermission,
  selectStatus,
} from "@/features/auth/authSlice";
import HttpError from '../components/httperror/HttpError';

const AppRouter = () => {
  const router = createHashRouter(addNavGuard(routes));

  return <RouterProvider router={router} />;
};
export default AppRouter;

const addNavGuard = (routes) => {
  return routes.map((x) => {
    const { element, children, ...route } = x;
    route.element = <NavGuard route={x} />;
    if (children?.length > 0) {
      route.children = addNavGuard(children);
    }
    return route;
  });
};

const NavGuard = ({ route }) => {
  usePageViews();
  const location = useLocation();
  const status = useSelector(selectStatus);
  const perms = useSelector(selectPermission);
  // console.log("Perms:" + perms);
  // console.log("status:" + status);
  // console.log("route:" + JSON.stringify(route));
  
  if (!route.anonymous) {
    if (status !== AUTH_STATUS.SUCCEEDED) {
      let from = location.search
        ? `${location.pathname}${location.search}`
        : location.pathname;
      return <Navigate to="/signin" state={{ from }} />;
    } else {
      if (status === AUTH_STATUS.SUCCEEDED && (perms == null || perms.length === 0)) {
        return <HttpError layout={route.layout} code={401} />;
      } else {
        if (route.auth && !perms.includes(route.auth) && !perms.includes('*')) {
          return <HttpError layout={route.layout} code={403} />;
        }
      }
    } 
  } else {
    if (status === AUTH_STATUS.SUCCEEDED && (perms == null || perms.length === 0) && route.path !== '/home') {
      return <HttpError layout={route.layout} code={401} />;
    }
  }  

  return route.layout ? (
    <Suspense fallback={<Fallback />}>
      <route.layout menu={route.menu}>{route.element}</route.layout>
    </Suspense>
  ) : (
    <Suspense fallback={<Fallback />}>{route.element}</Suspense>
  );
};

function Fallback() {
  return <div className="fallback-wrapper"></div>;
}

function usePageViews() {
  let location = useLocation();
  useEffect(() => {
    //console.log("[usePageViews]: ", location.pathname);
  }, [location.pathname]);
}
